/**
 * Entity base module.
 *
 */

import { InputSuggestionItem } from '@/lib/formFactory/inputSuggestion.interface';
import { VuexModule, Mutation, Action } from 'vuex-module-decorators';

export default abstract class EntityBaseModule extends VuexModule {
    id = '';
    isLoading = true;
    model: any;

    @Mutation
    SET_IS_LOADING(isLoading: boolean) {
        this.isLoading = isLoading;
    }

    @Mutation
    SET_ID(id: string) {
        this.id = id;
    }

    @Mutation
    SET_CREATED_AT(date: string) {
        this.model.createdAt = date;
    }

    @Mutation
    SET_UPDATED_AT(date: string) {
        this.model.updatedAt = date;
    }

    @Mutation
    SET_MULTI_SELECT_LIST_BY_TYPE(params: { type: string; list: any[] }) {
        this.model[params.type].list = params.list;
    }

    @Mutation
    SET_SUGGESTIONS_VALUE_BY_TYPE(params: { type: string; value: string }) {
        this.model[params.type].value = params.value;
    }

    @Mutation
    SET_SUGGESTIONS_CURRENT_BY_TYPE(params: { type: string; current: InputSuggestionItem }) {
        this.model[params.type].current = params.current;
    }

    @Mutation
    SET_SUGGESTIONS_HINTS_LIST_BY_TYPE(params: { type: string; list: InputSuggestionItem[] }) {
        this.model[params.type].hintsList = params.list;
    }

    @Mutation
    SET_DISABLED_BY_TYPE(params: { type: string; disabled: boolean }) {
        if (!this.model[params.type]) {
            return;
        }
        
        this.model[params.type].disabled = params.disabled;
    }

    @Action({ rawError: true })
    updateSuggestionsCurrentByType(params: { type: string; current: InputSuggestionItem }) {
        this.context.commit('SET_SUGGESTIONS_VALUE_BY_TYPE', { type: params.type, value: params.current.value });
        this.context.commit('SET_SUGGESTIONS_CURRENT_BY_TYPE', { type: params.type, current: params.current });
    }

    @Action({ rawError: true })
    prepareData() {
        return { name: this.model.name.value };
    }
}
